/// <reference path="../typings/tsd.d.ts" />

import { PartialViews, Routes, AppServices, AppControllers } from './helpers/config_keys';
import { AppRoutes } from "./app_routes"
import { RequestInterceptor } from './services/request_interceptor';
import { MainCtrl } from "./main/main_ctrl"
import { DashboardCtrl } from "./main/dashboard_ctrl"
import { LoginCtrl } from "./authentication/login_ctrl"
import { UserProfileCtrl } from "./user_profile/user_profile_ctrl"
import { AuthService, IAuthService } from "./authentication/auth_service"
import { Authorize, UnAuthorize } from './authentication/authorize'
import { SettingsCtrl } from './settings/settings_ctrl';
import { SettingCtrl } from './settings/settings_ctrl';
import { UsersCtrl } from './admin/users_ctrl';
import { RolesCtrl } from './admin/roles_ctrl';
import { UserService } from './admin/user_service';
import { RoleService } from './admin/role_service';
import { ReportViewerCtrl } from './reports/report_viewer_ctrl';
import { ReportsCtrl } from './reports/reports_ctrl';
import { ReportsConfig } from './reports/report_config';
import { ReportService } from "./reports/report_service";
import { LookUpService } from './settings/lookup_service';
import { AuthRun, TemplatesConfig, XeditableConfig, DatePickerConfig, ChartConfig, HotKeysConfig, AutoValidateConfig } from "./app_config";
import { TopUpService } from './topup/topup_service';
import { TopUpPaymentCtrl } from './topup/payment_ctrl';
import { TopUpRequestCtrl } from './topup/request_ctrl';
import { ContactService } from './address/contact_service';
import { GroupService } from './address/group_service';
import { MessageService } from './messenger/message_service';
import { DataUploadService } from './data_upload/data_upload_service';
import { DataUploadCtrl } from './data_upload/data_upload_ctrl';
import { ContactsCtrl } from './address/contacts_ctrl';
import { GroupsCtrl } from './address/groups_ctrl';
import { MessagePortalCtrl } from './messenger/message_portal_ctrl';
import { MessengerCtrl } from './messenger/messenger_ctrl';

let app = angular.module('app', ['ui.router', 'ui.bootstrap', 'ui.select2', 'ngAnimate', 'ngSanitize', 'alcoder.components', 'alcoder.services', 'xeditable', 'chart.js', 'cfp.hotkeys', 'jcs-autoValidate'])
	.directive(Authorize.Name, Authorize.Factory())
	.directive(UnAuthorize.Name, UnAuthorize.Factory())
	.controller(AppControllers.LoginCtrl, LoginCtrl)
	.controller(AppControllers.UserProfileCtrl, UserProfileCtrl)
	.controller(AppControllers.MainCtrl, MainCtrl)
	.controller(AppControllers.DashboardCtrl, DashboardCtrl)
	.controller(AppControllers.SettingsCtrl, SettingsCtrl)
	.controller(AppControllers.SettingCtrl, SettingCtrl)
	.controller(AppControllers.UsersCtrl, UsersCtrl)
	.controller(AppControllers.RolesCtrl, RolesCtrl)
	.controller(AppControllers.ReportsCtrl, ReportsCtrl)
	.controller(AppControllers.ReportViewerCtrl, ReportViewerCtrl)
	.controller(AppControllers.TopUpPaymentCtrl, TopUpPaymentCtrl)
	.controller(AppControllers.TopUpRequestCtrl, TopUpRequestCtrl)
	.controller(AppControllers.ContactsCtrl, ContactsCtrl)
	.controller(AppControllers.GroupsCtrl, GroupsCtrl)
	.controller(AppControllers.MessagePortalCtrl, MessagePortalCtrl)
	.controller(AppControllers.MessengerCtrl, MessengerCtrl)
	.controller(AppControllers.DataUploadCtrl, DataUploadCtrl)
	.service(AppServices.RequestInterceptor, RequestInterceptor)
	.service(AppServices.AuthService, AuthService)
	.service(AppServices.UserService, UserService)
	.service(AppServices.RoleService, RoleService)
	.service(AppServices.LookUpService, LookUpService)
	.service(AppServices.ReportsConfig, ReportsConfig)
	.service(AppServices.TopUpService, TopUpService)
	.service(AppServices.ContactService, ContactService)
	.service(AppServices.GroupService, GroupService)
	.service(AppServices.MessageService, MessageService)
	.service(AppServices.DataUploadService, DataUploadService)


app.config(AppRoutes);

app.value("BASEAPI", "api");
app.run(AuthRun);
app.run(TemplatesConfig);
app.run(XeditableConfig);
app.run(AutoValidateConfig);

app.config(DatePickerConfig);
app.config(ChartConfig);
app.config(HotKeysConfig)

//Hide Preloader
$("#preloader-body").hide();

export { app }


// WEBPACK FOOTER //
// ./app/app.ts